jQuery.fn.rater = function(url, options) {
    var settings = {
        url: url,
        maxvalue: 5,
        curvalue: 0,
        active: 'true'
    };
    if (options) {
        jQuery.extend(settings, options);
    };
    jQuery.extend(settings, {
        cancel: (settings.maxvalue > 1) ? true : false
    });
    var container = jQuery(this);
    jQuery.extend(container, {
        averageRating: settings.curvalue,
        url: settings.url
    });
	var e;
	PM.emitEvent("init.starrater", [(e = new $.Event("init.starrater")), settings, container])
	if (e.isDefaultPrevented()) return;
    if (!settings.style || settings.style == null || settings.style == 'basic') {
        var raterwidth = settings.maxvalue * 25;
        var ratingparent = '<ul class="star-rating" style="width:' + raterwidth + 'px">';
    }
    container.append(ratingparent);
    var starWidth, starIndex, listitems = '';
    var curvalueWidth = Math.floor(100 / settings.maxvalue * settings.curvalue);
    for (var i = 0; i <= settings.maxvalue; i++) {
        if (i == 0) {
            listitems += '<li class="current-rating" style="width:' + curvalueWidth + '%;">' + settings.curvalue + ' / ' + settings.maxvalue + '</li>';
        } else {
            starWidth = Math.floor(100 / settings.maxvalue * i);
            starIndex = (settings.maxvalue - i) + 2;
            if (settings.active == 'true') {
                listitems += '<li class="star"><a href="#' + i + '" title="' + i + '/' + settings.maxvalue + '" style="width:' + starWidth + '%;z-index:' + starIndex + '"></a></li>';
            } else {
                listitems += '<li class="star"></li>';
            }
        }
    }
    container.find('.star-rating').append(listitems);
    if (settings.maxvalue > 1) {
        container.append('<div class="star-rating-result">' + settings.curvalue + ' / ' + settings.maxvalue + '</div><div style="clear:both;"></div>');
    }
    var stars = jQuery(container).find('.star-rating').children('.star');
    stars.on('click', function() {
        if (settings.maxvalue == 1) {
            settings.curvalue = (settings.curvalue == 0) ? 1 : 0;
            jQuery(container).find('.star-rating').children('.current-rating').css({
                width: (settings.curvalue * 100) + '%'
            });
            jQuery.post(container.url, {
                "rating": settings.curvalue
            });
            return false;
        } else {
            settings.curvalue = stars.index(this) + 1;
            raterValue = jQuery(this).children('a')[0].href.split('#')[1];
            container.find('.star-rating').fadeOut();
            container.find('div.star-rating-result').fadeOut();
			PM.emitEvent("rate.product", [raterValue, container.url.replace(/.*urun_id=([0-9]+)/gi, "$1")]);
            jQuery.post(container.url, {
                "rating": raterValue
            }, function(response) {
				
                container.children('.star-rating-result').html(response)
                container.find('.star-rating').remove();
                container.find('div.star-rating-result').remove();
                container.rater(url = '', {
                    maxvalue: settings.maxvalue,
                    curvalue: $('#urun_detay_suanki_oy').val(),
                    active: 'false'
                });
                container.find('.star-rating').hide().fadeIn("fast");
                container.find('div.star-rating-result').hide().fadeIn("fast");
            });
            return false;
        }
        return true;
    });
    return this;
}